import { render, staticRenderFns } from "./fieldMail.vue?vue&type=template&id=4eda6047"
import script from "./fieldMail.vue?vue&type=script&lang=js"
export * from "./fieldMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eda6047')) {
      api.createRecord('4eda6047', component.options)
    } else {
      api.reload('4eda6047', component.options)
    }
    module.hot.accept("./fieldMail.vue?vue&type=template&id=4eda6047", function () {
      api.rerender('4eda6047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldMail.vue"
export default component.exports